<template>
    <div class="wrapper-bg main-layout ">
        <HeaderTitleSvg
            :setTitle="titilesvg"
            :setHref="'profile'"
            :showLogo="true"
        />
        <div class="wrapper-main pt-2">
            <!-- eslint-disable vue/no-v-html -->
            <div class="detail" v-html="cookiePolicy"></div>
            <!--eslint-enable-->
        </div>
    </div>
</template>
<script>
//core
import BzbsCustom from "@/core/Custom/service/BzbsCustom.js";
//component
import HeaderTitleSvg from "@/components/Header/HeaderTitleSvg.vue";
export default {
    name: "cookiePolicy",
    components: {
        HeaderTitleSvg
    },
    data: function() {
        return {
            cookiePolicy: null,
            titilesvg: require("@/assets/profile/cookie-policy-new.svg")
        };
    },
    created: function() {
        this.getBlobData();
    },
    methods: {
        getBlobData() {
            const url = "/nestle/pdpaconsent/cookie/1054";
            return new Promise((resolve, reject) => {
                BzbsCustom.apiGetCustom(url)
                    .then(response => {
                        this.cookiePolicy = response;
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },
        clickBack() {
            this.$router.push(`/profile`);
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper-bg {
    background: linear-gradient(
        180deg,
        rgba(255, 252, 244, 0.9) 0.3%,
        rgba(255, 252, 244, 0.95) 20%,
        #fffcf4 100%
    );
}
.wrapper-main {
    padding: 20px;
    .detail {
        font-size: 14px;
        color: #6f5948;
    }
}
</style>
